(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/hooks/assets/javascripts/use-draw-query-params.js') >= 0) return;  svs.modules.push('/components/pool-betting/hooks/assets/javascripts/use-draw-query-params.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useState = _React.useState;
const _svs$components$sport = svs.components.sport.tipsenShared,
  PARAM_DRAWNUMBER = _svs$components$sport.PARAM_DRAWNUMBER,
  PARAM_PRODUCT_ID = _svs$components$sport.PARAM_PRODUCT_ID;
const useDrawQueryParams = () => {
  const location = useLocation();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    productId = _useState2[0],
    setProductId = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    drawNumber = _useState4[0],
    setDrawNumber = _useState4[1];
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get(PARAM_DRAWNUMBER)) {
      setDrawNumber(searchParams.get(PARAM_DRAWNUMBER));
    }
    if (searchParams.get(PARAM_PRODUCT_ID)) {
      setProductId(searchParams.get(PARAM_PRODUCT_ID));
    }
  }, [location.search]);
  return useMemo(() => ({
    drawNumber,
    productId
  }), [drawNumber, productId]);
};
setGlobal('svs.components.poolBetting.hooks.useDrawQueryParams', useDrawQueryParams);

 })(window);